import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { Observable } from "rxjs";
import {League, LeagueEvents, UserEvent} from "@model";
import { PublicLeagueDataStore } from "@store";

export const PublicLeagueDetailsResolver = PublicLeagueDataStore.on<PublicLeagueDataStore, League>(s => s.currentLeague$);
export const PublicLeagueEventsResolver  = PublicLeagueDataStore.on<PublicLeagueDataStore, LeagueEvents>(s => s.leagueEvents$);